import PropTypes from "prop-types";
import React from "react";
import { editDeleteStyles } from "../../../globals";
import Modal from "../../Modal/Modal";
import STSComponent from "../../STSComponent/STSComponent";

class AddNewItem extends STSComponent {
  render() {
    const {
      modalType,
      title,
      toAdd,
      toCancel,
      content,
      customStyles,
      newIdentifier,
      modal,
      savingNotAvailable,
      zIndex,
    } = this.props;

    return (
      <Modal
        modalType={`Add-new-item-${modalType}`}
        contentLabel={`Add-new-item-${modalType}`}
        customStyles={editDeleteStyles[customStyles] || editDeleteStyles.edit}
        modal={modal}
        zIndex={ zIndex ? zIndex : 97 }
      >
        <div className="get-report-modals-titlearea">
          <span className="get-report-modals-title">
            {newIdentifier || "New"} {title}
          </span>
        </div>
        {content}
        <div className="get-report-modals-buttons-area buttonsarea-type2">
          <button
            onClick={toAdd}
            disabled={savingNotAvailable}
          >
            Add {title}
          </button>
          <button onClick={toCancel}>Cancel</button>
        </div>
      </Modal>
    );
  }

  static propTypes = {
    modalType: PropTypes.string,
    title: PropTypes.string,
    toCancel: PropTypes.func,
    toAdd: PropTypes.func,
    content: PropTypes.node,
    customStyles: PropTypes.string,
    newIdentifier: PropTypes.string,
    modal: PropTypes.object,
    savingNotAvailable: PropTypes.bool,
  };
}

export default AddNewItem;



// WEBPACK FOOTER //
// ./src/components/Modal/components/AddNewItem.js